import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const BUILD_VERSION = process.env.VUE_APP_BUILD_VERSION || ''
const VERSION_KEY = 'ylk_app_v'

if (BUILD_VERSION) {
  const stored = localStorage.getItem(VERSION_KEY)
  if (stored && stored !== BUILD_VERSION) {
    localStorage.setItem(VERSION_KEY, BUILD_VERSION)
    const url = new URL(window.location.href)
    url.searchParams.set('_v', BUILD_VERSION)
    window.location.replace(url.toString())
  } else if (!stored) {
    localStorage.setItem(VERSION_KEY, BUILD_VERSION)
  }
}

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.mount('#app')